"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpacedRepModuleConfig = void 0;
const types_1 = require("../main/types");
class SpacedRepModuleConfig extends types_1.SpacedRepModuleConfigType {
    isValidConfiguration() {
        // / id
        if (!this.id || this.id.length === 0) {
            return false;
        }
        // / cardMER
        if (this.cardMER.mer0.length != 13 ||
            !this.cardMER.mer0.every((num) => num === Math.floor(num) && num >= 0)) {
            return false;
        }
        if (this.cardMER.mer1.length != 13 ||
            !this.cardMER.mer1.every((num) => num === Math.floor(num) && num >= 0)) {
            return false;
        }
        if (this.cardMER.mer2.length != 13 ||
            !this.cardMER.mer2.every((num) => num === Math.floor(num) && num >= 0)) {
            return false;
        }
        if (this.cardMER.mer3.length != 13 ||
            !this.cardMER.mer3.every((num) => num === Math.floor(num) && num >= 0)) {
            return false;
        }
        if (this.cardMER.mer4.length != 13 ||
            !this.cardMER.mer4.every((num) => num === Math.floor(num) && num >= 0)) {
            return false;
        }
        // / dailyStudyCount
        if (this.dailyStudyCount.length != 5 ||
            !this.dailyStudyCount.every((num) => num === Math.floor(num) && num > 0)) {
            return false;
        }
        // / deckLength
        if (this.deckLength.length != 5 ||
            !this.deckLength.every((num) => num === Math.floor(num) && num > 0)) {
            return false;
        }
        // / speedyFactor
        if (this.speedyFactor.length != 5) {
            return false;
        }
        // / nonSpeedyFactor
        if (this.nonSpeedyFactor.length != 5) {
            return false;
        }
        // / thirdChanceFactor
        if (this.thirdChanceFactor.length != 5) {
            return false;
        }
        // / speedyAnswerTime
        if (this.speedyAnswerTime.length != 5) {
            return false;
        }
        // / rightAnswerDisplayTime
        if (this.rightAnswerDisplayTime.length != 5) {
            return false;
        }
        // / wrongAnswerDisplayTime
        if (this.wrongAnswerDisplayTime.length != 5) {
            return false;
        }
        // / rightMax
        if (this.rightMax.length != 5 ||
            !this.rightMax.every((num) => num === Math.floor(num) && num > 0)) {
            return false;
        }
        // / rightMin
        if (this.rightMin.length != 5 ||
            !this.rightMin.every((num) => num === Math.floor(num) && num > 0)) {
            return false;
        }
        // / wrongMax
        if (this.wrongMax.length != 5 ||
            !this.wrongMax.every((num) => num === Math.floor(num) && num > 0)) {
            return false;
        }
        // / wrongMin
        if (this.wrongMin.length != 5 ||
            !this.wrongMin.every((num) => num === Math.floor(num) && num > 0)) {
            return false;
        }
        return true;
    }
}
exports.SpacedRepModuleConfig = SpacedRepModuleConfig;
SpacedRepModuleConfig.converter = {
    toFirestore(data) {
        return {
            cardMER: data.cardMER,
            dailyStudyCount: data.dailyStudyCount,
            deckLength: data.deckLength,
            deckMode: data.deckMode,
            orientationInfo: data.orientationInfo,
            speedyFactor: data.speedyFactor,
            nonSpeedyFactor: data.nonSpeedyFactor,
            thirdChanceFactor: data.thirdChanceFactor,
            speedyAnswerTime: data.speedyAnswerTime,
            rightAnswerDisplayTime: data.rightAnswerDisplayTime,
            wrongAnswerDisplayTime: data.wrongAnswerDisplayTime,
            rightMax: data.rightMax,
            rightMin: data.rightMin,
            wrongMax: data.wrongMax,
            wrongMin: data.wrongMin
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const cardMER = documentData.cardMER;
        const dailyStudyCount = documentData.dailyStudyCount;
        const deckLength = documentData.deckLength;
        const deckMode = documentData.deckMode;
        const orientationInfo = documentData.orientationInfo;
        const speedyFactor = documentData.speedyFactor;
        const nonSpeedyFactor = documentData.nonSpeedyFactor;
        const thirdChanceFactor = documentData.thirdChanceFactor;
        const speedyAnswerTime = documentData.speedyAnswerTime;
        const rightAnswerDisplayTime = documentData.rightAnswerDisplayTime;
        const wrongAnswerDisplayTime = documentData.wrongAnswerDisplayTime;
        const rightMax = documentData.rightMax;
        const rightMin = documentData.rightMin;
        const wrongMax = documentData.wrongMax;
        const wrongMin = documentData.wrongMin;
        const data = new SpacedRepModuleConfig(id, cardMER, dailyStudyCount, deckLength, deckMode, orientationInfo, speedyFactor, nonSpeedyFactor, thirdChanceFactor, speedyAnswerTime, rightAnswerDisplayTime, wrongAnswerDisplayTime, rightMax, rightMin, wrongMax, wrongMin);
        return data;
    }
};
